import Weather from "./Weather";
import './App.css';

export default function App() {
  return (
    <div className="App">
      <div className="container">
     
    <Weather cityName="Tokyo" />
    <footer>This project was coded by Beatriz Bonadia and is an <a href="https://github.com/biabonadia/forecast-react-app"  target="_blank">open-sourced on GitHub</a></footer>
</div>
    </div>
  );
}


